import { ActionTree, ActionContext } from 'vuex';

import { subsClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { SubsStateI } from './state';

export const actions: ActionTree<SubsStateI, RootStateI> = {
  async enrolltrial(
    context: ActionContext<SubsStateI, RootStateI>,
    payload: { serviceName: string; planId: string },
  ): Promise<void> {
    const { data } = await subsClient.post(
      `/api/subscriptions/enrolltrial?service_name=${payload.serviceName}&plan_id=${payload.planId}`,
    );
    context.commit('setSub', snakeToCamel(data));
    return data;
  },
  async enrollpaid(
    context: ActionContext<SubsStateI, RootStateI>,
    payload: { serviceName: string; planId: string },
  ): Promise<void> {
    const { data } = await subsClient.post(
      `/api/subscriptions/enrollpaid?service_name=${payload.serviceName}&plan_id=${payload.planId}`,
    );
    context.commit('setSub', snakeToCamel(data));
    return data;
  },
  async checksubpayment(
    context: ActionContext<SubsStateI, RootStateI>,
    payload: string,
  ): Promise<void> {
    const { data } = await subsClient.post(
      `/api/subscriptions/checksubpayment?payment_id=${payload}`,
    );
    const {
      invoice,
      plan,
      service,
      subscription,
      payment,
    } = snakeToCamel(data);
    context.commit('invoices/setInvoice', invoice, { root: true });
    context.commit('plans/setPlan', plan, { root: true });
    context.commit('services/setService', service, { root: true });
    context.commit('setSub', subscription);
    context.commit('payments/setPayment', payment, { root: true });
    return data;
  },
};
